<div class="contentStyle">
    <mat-sidenav-container class="sidenav-container">
        <mat-sidenav #drawer class="sidenav" fixedInViewport
            [attr.role]="(isHandset$ | async) ? 'dialog' : 'navigation'" [mode]="(isHandset$ | async) ? 'over' : ''">
            <mat-toolbar>
                <span class="titleMenu">{{ "menu.title" | translate }}</span>
                <div class="closeIcon">
                    <em class="fal fa-times" (click)="drawer.toggle()"></em>
                </div>
            </mat-toolbar>
            <mat-nav-list>
                <a mat-list-item routerLink="{{routesPath['users']}}" (click)="drawer.close()">
                    <div class="listIconHome"><em class="far fa-users"></em></div>
                    {{ "menu.users" | translate }}
                </a>
                <a mat-list-item routerLink="{{routesPath['plants']}}" (click)="drawer.close()">
                    <div class="listIconWarehouse"><em class="far fa-inventory"></em></div>
                    {{ "menu.warehouses" | translate }}
                </a>
                <mat-divider></mat-divider>
                <mat-expansion-panel class="panelContainer" #mapanel="matExpansionPanel">
                    <mat-expansion-panel-header class="panelHeader">
                        <mat-panel-title class="panelTitle">
                            <div class=" listIconGlobe"><em class="far fa-globe"></em></div>
                            {{ "menu.languagesMenu" | translate }}
                        </mat-panel-title>
                    </mat-expansion-panel-header>
                    <div class="panelBody">
                        <mat-list-item (click)="switchLang('es'); drawer.close(); mapanel.close()"><span
                                class="itemLanguage"
                                [ngClass]="{'selected': isSelected('es')}">{{'langCode.es' | translate}}</span>
                        </mat-list-item>
                        <mat-list-item (click)="switchLang('en'); drawer.close(); mapanel.close()"><span
                                class="itemLanguage"
                                [ngClass]="{'selected': isSelected('en')}">{{'langCode.en' | translate}}</span>
                        </mat-list-item>
                    </div>
                    <mat-divider></mat-divider>
                </mat-expansion-panel>
            </mat-nav-list>
            <mat-nav-list class="fixed-bottom">
                <a mat-list-item (click)="logOut()">
                    <div class="listIconHome"><em class="far fa-sign-out"></em></div>
                    {{ "menu.exit" | translate }}
                </a>
            </mat-nav-list>
        </mat-sidenav>
        <mat-sidenav-content>
            <mat-toolbar color="primary">
                <div *ngIf="!disabled" class="listIconToolbar" (click)="drawer.toggle()">
                    <em class="far fa-bars"></em>
                </div>
                <span class="example-spacer">{{titlePage | translate}}</span>
            </mat-toolbar>
            <app-snack-bar></app-snack-bar>
            <router-outlet></router-outlet>
        </mat-sidenav-content>
    </mat-sidenav-container>
</div>